module.exports = __webpack_public_path__ + "img/sublime-copy-filepaths.jpg_w545.ef558b0a.jpg";